export default "__VITE_ASSET__CzCmwGem__"